import { render, staticRenderFns } from "./Bayar.vue?vue&type=template&id=71dd5ba5&"
import script from "./Bayar.vue?vue&type=script&lang=js&"
export * from "./Bayar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports